export const getDialogTextFieldSx = (isDark: boolean) => ({
  '& .MuiInputLabel-root': {
    fontSize: '14px',
    fontWeight: 600,
    color: isDark ? '#94a3b8' : '#475569',
    '&.Mui-focused': { color: '#3b82f6', fontWeight: 600 },
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: '14px',
    color: isDark ? '#e2e8f0' : '#1e293b',
    '& fieldset': { borderColor: isDark ? 'rgba(255,255,255,0.15)' : '#cbd5e1' },
    '&:hover fieldset': { borderColor: isDark ? 'rgba(255,255,255,0.3)' : '#93c5fd' },
    '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '2px' },
    '&.Mui-disabled': { cursor: 'not-allowed', '& *': { cursor: 'not-allowed' } },
  },
  '& .MuiInputBase-input::placeholder': {
    color: isDark ? '#64748b' : '#94a3b8',
    opacity: 1,
  },
})

export const dialogBackdropProps = {
  BackdropProps: {
    sx: {
      backgroundColor: 'rgba(15, 23, 42, 0.4)',
      backdropFilter: 'blur(4px)',
    },
  },
}
